import { render, staticRenderFns } from "./batchYY.vue?vue&type=template&id=0adc1e59&scoped=true"
import script from "./batchYY.vue?vue&type=script&lang=js"
export * from "./batchYY.vue?vue&type=script&lang=js"
import style0 from "./batchYY.vue?vue&type=style&index=0&id=0adc1e59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc1e59",
  null
  
)

export default component.exports